import * as RouteNames from "./route-names";
import * as SharedRoutes from "@/shared/route-names";

const partnerPages = [
  RouteNames.PartnerHome,
  RouteNames.PartnerEmployeeSearch,
  RouteNames.PartnerSettings,
  RouteNames.PartnerUsers,
  RouteNames.PartnerUserAdd,
  RouteNames.PartnerNewEmployer,
  RouteNames.PartnerBillingReport,
  RouteNames.PartnerReports,
  RouteNames.PartnerReportRenderQs,
  RouteNames.PartnerReportsListQs,
  RouteNames.PartnerSecurity,
  RouteNames.PartnerCommunicationsAccountHolder,
  RouteNames.PartnerCommunicationsEmployer,
  RouteNames.PartnerResourceForms,
  RouteNames.EmailHistory,
  RouteNames.BulkLiquidationManagement,
];

export const isPartnerPage = (routeName: string) => partnerPages.includes(routeName);

const servicePages = [
  RouteNames.PartnerAccountHolderDashboard,
  RouteNames.PartnerAccountHolderCashTrx,
  RouteNames.PartnerAccountHolderExpenses,
  RouteNames.PartnerAccountHolderContribution,
  RouteNames.PartnerAccountHolderInvestment,
  RouteNames.UmbInvestmentAccount,
  RouteNames.TdaInvestmentAccount,
  SharedRoutes.DrivewealthInvestmentAccount,
  SharedRoutes.DrivewealthInvestmentAccountV2,
  SharedRoutes.DrivewealthAvailableInvestments,
  SharedRoutes.DrivewealthAvailableInvestmentsV2,
  SharedRoutes.DrivewealthInvestmentActivity,
  SharedRoutes.DrivewealthInvestmentActivityV2,
  SharedRoutes.DrivewealthInvestmentDocuments,
  SharedRoutes.DrivewealthInvestmentDocumentsV2,
  SharedRoutes.DrivewealthInvestmentDayTrades,
  SharedRoutes.DrivewealthInvestmentDayTradesV2,
  SharedRoutes.DrivewealthInvestmentFeesV2,
  SharedRoutes.DrivewealthInvestmentAccountList,
  RouteNames.DrivewealthSellInstrumentV2,
  RouteNames.HsabInvestmentAccount,
  RouteNames.PartnerAccountHolderManagement,
  SharedRoutes.DrivewealthAccountLiquidation
];

export const isCustomerServicePage = (routeName: string) => servicePages.includes(routeName);
